import { axiosApiClient } from "../index";

const BASE_URL = "/user";

const EmailVerificationService = {
  // Send verification email
  sendVerificationEmail: async (email) => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/send-verification-email`,
        {
          email,
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Verify email with token
  verifyEmail: async (token) => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/verify-email?token=${token}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Resend verification email
  resendVerificationEmail: async () => {
    try {
      const response = await axiosApiClient.post(
        `${BASE_URL}/resend-verification-email`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get verification status
  getVerificationStatus: async () => {
    try {
      const response = await axiosApiClient.get(
        `${BASE_URL}/verification-status`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default EmailVerificationService;
